import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const MCEadTitle = (props) => {
    const {
        style
    } = props

    const smallCls =  props.small ? ' small ' : ''
    return (
        <h1 style={style} className={'mc-ead-title ' + smallCls}>
            {props.title}
        </h1>
    )
}

MCEadTitle.propTypes = {
    title: PropTypes.string.isRequired,
    small: PropTypes.bool,
}

MCEadTitle.defaultProps = {
    small: false
}

export default MCEadTitle



// WEBPACK FOOTER //
// ./src/components/_ead/Title/index.js